import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Swal from 'sweetalert2';
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";

const AddNewAgent = () => {
  const [formData, setFormData] = useState({});
  const [isMainFormSubmitted, setIsMainFormSubmitted] = useState(false);
  const [activeSection, setActiveSection] = useState('Customer');
  const [onboardId, setOnboardId] = useState(null); // State to store onboardId
  const [ onBoardStatus, setOnBoardStatus ] = useState(null)
  const [ isButtonVisible, setIsButtonVisible ] = useState(true)
  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);
  const [ menuDropdown, setMenuDropdown ] = useState([])
  const [isFormSubmittedSuccessfully, setIsFormSubmittedSuccessfully] = useState(false);
  const [responseerrormessage,setResponseErrorMessage] = useState('')
  const token = localStorage.getItem("authToken");

  console.log(token, "TOKEN")

  const authToken = localStorage.getItem("authToken");
  console.log(authToken, "AUTHTOKEN")

  const [businessPartnertypedd, setBusinessPartnerTypedd] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [validationErrors, setValidationErrors] = useState({});

  const location = useLocation();
  const { data } = location.state || {};
  console.log(location, "LOCATION")

  console.log(data, "DAATAONBOARD")

  const navigate = useNavigate();

  const handleDocumentFormSubmit = (data) => {
    console.log("Document Form Data:", data);

    navigate(ROUTES_NAVIGATION.CUSTOMERDETAILS);
  };

  const handleNavigate = () => {
    navigate('/admin/manage-onboard/onboard/create-customer');
  };

  useEffect(() => {
    fetchMenuDropdown();
  },[])

  const fetchMenuDropdown = async () => {
    try {
      const response = await axiosInstance.get('/bp-onboard/menu',{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const formattedData = response.data.data.data
      const menuOptions = formattedData.map(item => ({
        value: item.menu_id,
        label: item.menu_name,
      }));
      setMenuDropdown(menuOptions);
      console.log(formattedData, "MENU DROPDOWN DATA")

    } catch (error) {
      console.error('Error fetching campaign list:', error);
    }
  };
  


  console.log( "UploadDocument",formData);
  
  const handleFormSubmit = async (formData) => {
    console.log("formDataHandleSubmit", formData);
  
    const errors = {};
    let isValid = true;
  
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Confirmation Alert
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to proceed with the submission?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });
  
    if (!confirmation.isConfirmed) {
      // User cancelled the submission
      Swal.fire({
        title: 'Cancelled',
        text: 'Your submission has been cancelled.',
        icon: 'info',
      });
      return;
    }
  
    setIsLoading(true);
  
    console.log("clicked");
    try {
      const response = await axiosInstance.post(
        "/bp-onboard/create",
        {
          onboard_process_type: formData.onboard_process_type,
          onboard_status: 2,
          bp_type: formData.business_partner_type,
          bp_name: formData.bp_name,
          contact_no: formData.contact_no,
          email_id: formData.email_id,
          pincode: formData.pincode,
          city_id: formData.city_id,
          country_id: formData.country_id,
          state_id: formData.state_id,
          bp_address: formData.bp_address,
          gst_no: formData.gst_no,
          status: formData.status == "Active" ? 1 : 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
  
      console.log("APIResponse", response.data?.data);
      const onboardid = response?.data?.data?.onboard_id;
      const onBoardStatus = response?.data?.data?.onboard_status;
      setOnBoardStatus(onBoardStatus);
      console.log(onBoardStatus, "onBoardSttaus");
      setOnboardId(onboardid);
      console.log("onboardid>>>", onboardid);
  
      // Success Alert
      Swal.fire({
        title: 'Success!',
        text: 'Data submitted successfully!',
        icon: 'success',
      });
  
      setIsFormSubmittedSuccessfully(true);
      setIsButtonVisible(false);
    } catch (error) {
      console.log(error, "error");
  
      // Error Alert
      let errorMessage = 'Failed to Add Data. Please try again.';
      if (error.response && error.response.status === 403) {
        errorMessage = error.response.data.message || 'This record already exists.';
      }
  
      Swal.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleConfig = async (formData) => {
    console.log("handleconfigFormData",formData);
    // Check if any document is uploaded
const documents = [
  formData.adhaarcard,
  formData.pan,
  formData.cancelcheque,
  formData.agreementcopy,
  formData.businesslicense,
  formData.environmentalpolicy,
];

const hasDocuments = documents.some((doc) => doc);

if (!hasDocuments) {
  showCustomAlert({
    title: "No Documents Uploaded",
    text: "Please upload at least one document before proceeding.",
    icon: "warning",
    confirmButtonText: "OK",
  });
  return;
}
    const errors = {};
    let isValid = true;

    ConfigInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    CustomerInputsAfterSuccess.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    setIsLoading(true);

    // console.log("clicked", formData)

    showCustomAlert({
      title: "Success",
      text: "Are you sure you want to create this record?",
      icon: "success",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      callback: async () => {

    try {

      // Log the payload to be sent
    const payload = {
      max_hierarchy_level: formData.max_hierarchy_level,
      total_user: formData.total_user,
      user_prefix: formData.user_prefix,
    };
    console.log("Payload to be sent:", payload);

      const response = await axiosInstance.patch(`/bp-onboard/updateConfig/${onboardId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      console.log("API Response:", response.data);
      if (response.status === 200) {
        // Call uploadDocumentForm after successful configForm submission
        await uploadDocumentForm(formData);
        await createUpdateAcess(formData);
      }
      navigate("/admin/manage-onboard/onboard")
    } catch (error) {
      console.log(error, "error")
      // toastError("Failed to add product. Please try again.");
    } finally {
      setIsLoading(false)
    }
  },
});
  }

  const createUpdateAcess = async (formData) => {

    console.log(formData, "FORMDATAA")
    const menuAccessIds = formData.accessModule.join(",");

    const payload = {
      menu_access: menuAccessIds,
      onboard_status: 3,
      remark:formData.remarks,

    }
    console.log(payload, "UpdateAccess Payload")
    try {
      const resposne = await axiosInstance.patch(`/bp-onboard/updateAccess/${onboardId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      })

      console.log(resposne.data, "Api Resposne:")
    }catch (error) {
      console.log("ERROR", error)
      // toastError("Failed to add . Please try again.");
    } finally {
      setIsLoading(false)
    }
  }

  const uploadDocumentForm =  async() => {
  const uploadData = new FormData();

  // uploadData.append('document_type', "1","2","3","4");
  // uploadData.append("document_type", "'1','2','3','4'")
  uploadData.append("document_type","1,2,3,4,5,6")
  uploadData.append('onboard_bp_id', onboardId);

  if (formData.adhaarcard) {
    console.log("adhaar");
    
    uploadData.append('uploadFile', formData.adhaarcard);
  }
  if (formData.pancard) {
    console.log("pancard");
    uploadData.append('uploadFile', formData.pancard);
  }
  if (formData.cancelcheque) {
    console.log("cancelcheque");
    uploadData.append('uploadFile', formData.cancelcheque);
  }
  if (formData.agreementcopy) {
    console.log("agreementcopy");

    uploadData.append('uploadFile', formData.agreementcopy);
  }
  if (formData.businesslicense) {
    console.log("businesslicense");

    uploadData.append('uploadFile', formData.businesslicense);
  }
  if (formData.environmentalpolicy) {
    console.log("environmentalpolicy");

    uploadData.append('uploadFile', formData.environmentalpolicy);
  }

    try {
      const response = await axiosInstance.post('/bp-onboard/uploadDocument',uploadData, 
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        }
      }
    );
  
      console.log("added successfully:", response.data,uploadData);
      // toastSuccess("Product Data fetched successfully!"); 
      navigate(ROUTES_NAVIGATION.ONBOARD) 
    } catch (error) {
      console.error('Error adding unit:', error);
      // toastError("Failed to add product. Please try again.");
      console.error("Error submitting form:", error);
    }
    // const response = await axiosInstance.post("")

  }

  const fetchBusinessPartnerType = async () => {
    try {
      const resposne = await axiosInstance.post("/businesspartnertype/ddlbusinesspartnertype", {}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      })
      const options = resposne.data.data.data.map(data => ({
        label: data.NAME,
        value: data.ID,
      }));

      setBusinessPartnerTypedd(options)

    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    fetchBusinessPartnerType();
  }, [])

  const ConfigInputs = [
    {
      name: "max_hierarchy_level",
      label: "Max Hierarchy Level",
      placeholder: "Enter Max Hierarchy Level",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,message:"Max Hierarchy is required.",  maxLength:3 },

    },
    {
      name: "total_user",
      label: "Total Users",
      placeholder:"Enter Total Users",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      validation: { required: true,message:"Total Users is required." ,maxLength:3 },

    },
    {
      name: "user_prefix",
      label: "User Prefix",
      placeholder:"Enter User Prefix",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,message:"User Prefix is required." },
    },
  ]

  

  const CustomerInputsAfterSuccess = [
    {
      name: "adhaarcard",
      label: "Adhaar Card",
      type: "agentfile",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "pancard",
      label: "Pan Card",
      type: "agentfile",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "cancelcheque",
      label: "Cancel Cheque",
      type: "agentfile",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "agreementcopy",
      label: "Agreement Copy",
      type: "agentfile",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "businesslicense",
      label: "Business Licence & Permits",
      type: "agentfile",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "environmentalpolicy",
      label: "Environment Policy",
      type: "agentfile",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "actiondoc",
      label: "Action",
      required: true,
      type: "dropdown",
      options: [
        { label: "Update", value: 2 },
        { label: "Approve", value: 3 },
      ],
      gridClass: "col-lg-4",
      validation: { required: true},
    },
    {
      name: "accessModuleii",
      label: "Access Module",
      type: "multiselectdropdown",
      options: menuDropdown,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true},

    },
    {
      name: "remarks",
      label: "Remarks",
      placeholder:"Enter Remark",
      type: "text",
      required: false,
      gridClass: "col-lg-4",
    },
  ];

  const CustomerInputs = [
    {
      name: "onboard_process_type",
      label: "On Board Business Type",
      type: "hidden",
      // placeholder:"",
      // required: true,
      // gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "business_partner_type",
      label: "Business Partner Type",
      type: "dropdown",
      required: true,
      disabled:true,
      options: businessPartnertypedd,
      // options: [
      //   { label: "OEM", value: "OEM" },
      //   { label: "OEM2", value: "OEM2" },
      // ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "bp_name",
      label: "Business Partner Name",
      placeholder:"Enter Business Partner Name",
      maxLength: 50,
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, pattern: /^[A-Za-z0-9\'\-.,&()[\]]+(?:\s[A-Za-z0-9\'\-.,&()[\]]+)*$/,
        message: "Only alphanumeric characters, specific symbols, and single spaces between words are allowed*", maxLength:50}
    },
    {
      name: "contact_no",
      label: "Contact No.",
      placeholder:"Enter Contact Number",
      type: "text",
      maxLength:10,
      required: true,
      gridClass: "col-lg-4",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      }
    },
    {
      name: "email_id",
      label: "Email Address",
      placeholder:"Enter Email Address",
      type: "email",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email Address"},
    },
    {
      name: "bp_address",
      label: "Business Partner Address",
      placeholder:"Enter Business Partner Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,maxLength:50 },
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder:"Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true , maxLength:6, pattern:/^[1-9][0-9]{5}$/,message:"Invalid Pin Code*",responseerrormessage:responseerrormessage}
    },
    {
      name: "city",
      label: "City",
      type: "text",
      placeholder:"City",
      gridClass: "col-lg-4",
     // validation: { required: true },
      disabled:true
    },
    {
      name: "state",
      label: "State",
      type: "text",
      placeholder:"State",
      required: false,
      gridClass: "col-lg-4",
     // validation: { required: true },
      disabled:true
    },
    {
      name: "country",
      label: "Country",
      type: "text",
      placeholder:"Country",
      required: false,
      gridClass: "col-lg-4",
      //validation: { required: true },
      disabled:true
    },
    {
      name: "gst_no",
      label: "GST No.",
      type: "text",
      placeholder:"Enter Gst No.",
      // required: true,
      gridClass: "col-lg-4",
      validation: { 
        // required: true, 
        pattern: /^\d{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/, 
        message: "Please enter a valid 15-character GST number",
        maxLength:15
      },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id:1, label: "Active", value: "Active" },
        { id:0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "actioncust",
      label: "Action",
      required: true,
      type: "dropdown",
      options: [
        { label: "New", value: "New" },
      ],
      disabled:true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      onboard_process_type: "Agent"
    }));
  }, []);

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      action: "Update",
      actioncust:"New",
      business_partner_type:1
      
    }))
  }, []);

  useEffect(() => {
    if (formData.value === 3) {
      setShowAdditionalInputs(true);
    } else {
      setShowAdditionalInputs(true);
    }
  }, [formData.value]);

  const backNavigate = () => {
    navigate("/admin/manage-onboard/onboard")
  }

  return (
    <>
      <div className="backbutton mt-2 mb-2">
        <img onClick={backNavigate} src={backicon} alt="back" />
        <span className="backbtntitle">Add New Business Partner</span>
      </div>
      <div className="form-container">
        <div className="agentFormHeading">
      <button 
            // className={`OnboardManagamentButtons ${activeSection === 'Customer' ? 'onboardactive' : ''}`} 
            className={`OnboardManagamentButtons ${activeSection === 'Agent' ? 'onboardactive' : ''}`} 
            onClick={handleNavigate}
          >
            Customer
          </button>
          <button 
            className={`OnboardManagamentButtons ${activeSection === 'Customer' ? 'onboardactive' : ''}`} 
            // onClick={() => handleSectionChange('Agent')}
            onClick={handleNavigate}
          >
            Agent
          </button>
        </div>
        <div className="cust-det-title mt-2 mb-2">
          Please Enter Agent Details
        </div>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          setResponseErrorMessage={setResponseErrorMessage}
        />
      <div className="btncontainer mt-3">
      {isButtonVisible && (
          <button
            onClick={() => handleFormSubmit(formData)}
            className="submit-btn"
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        )}
      </div>

      {isFormSubmittedSuccessfully && (
        <>
          <div>
            <span className="backbtntitle">Configuration</span>
            <DynamicForm
              formConfig={ConfigInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
            {/* < button onClick={() =>handleConfig(formData)} >submit</button> */}
          </div>
          <div className="pt-4">
            <span className="backbtntitle">Upload Documents and Details</span>
            <DynamicForm
        formConfig={
        CustomerInputsAfterSuccess
        }
        formData={formData}
        setFormData={setFormData}
        onSubmit={uploadDocumentForm}
      
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
      />
          </div>

          <div onClick={()=>handleConfig(formData)} style={{cursor:"pointer"}} className="agentSubmit-btn ">
            Submit
          </div>
        </>
      )}
      </div>

    </>
  );
};

export default AddNewAgent;
